import { useSelector } from 'react-redux'
import { useMemo } from 'react'
import { DashboardTypes } from 'features/Codes'

export const useDashboardTableSelector = type => {
  const {
    common: { type: tab },
    table: { campaignTable, adGroupTable, keywordTable, creativeTable },
  } = useSelector(state => state.dashboard)
  const table = type || tab
  return useMemo(() => {
    if (table === DashboardTypes.AD_GROUP) {
      return adGroupTable
    } else if (table === DashboardTypes.KEYWORD) {
      return keywordTable
    } else if (table === DashboardTypes.CREATIVE) {
      return creativeTable
    } else {
      return campaignTable
    }
  }, [table, campaignTable, adGroupTable, keywordTable, creativeTable])
}
